import React from "react";
import { Link, useLocation } from "react-router-dom";

const ServiceArea = [
  {
    label: "Mecidiyeköy Halı Yıkama",
    path: "/sisli/mecidiyekoy-hali-yikama",
    description:
      "Mecidiyeköy semtinde halılarınız tam otomatik makinelerde yıkanır, hijyen garantili şekilde teslim edilir."
  },
  {
    label: "Bomonti Halı Yıkama",
    path: "/sisli/bomonti-hali-yikama",
    description:
      "Bomonti bölgesine özel profesyonel halı yıkama hizmeti, bireysel ve ticari tüm ihtiyaçlarınıza çözüm sunar."
  },
  {
    label: "Nişantaşı Halı Yıkama",
    path: "/sisli/nisantasi-hali-yikama",
    description:
      "Nişantaşı’nda halılarınız özenle ve değerine zarar vermeden yıkanır, şık ambalajlarla teslim edilir."
  },
  {
    label: "Okmeydanı Halı Yıkama",
    path: "/sisli/okmeydani-hali-yikama",
    description:
      "Okmeydanı semtinde uygun fiyatlı, garantili ve çevre dostu halı yıkama hizmeti sunuyoruz."
  },
  {
    label: "Halide Edip Mahallesi Halı Yıkama",
    path: "/sisli/halide-edip-hali-yikama",
    description:
      "Halide Edip Mahallesi’nde halılarınız hijyenik ve hızlı bir şekilde temizlenip kapınıza teslim edilir."
  },
  {
    label: "Kuştepe Mahallesi Halı Yıkama",
    path: "/sisli/kusteppe-hali-yikama",
    description:
      "Kuştepe Mahallesi’nde halı yıkama hizmetimizde ücretsiz servis, kaliteli deterjan ve hızlı teslim garantisi vardır."
  },
  {
    label: "Gülbahar Mahallesi Halı Yıkama",
    path: "/sisli/gulbahar-hali-yikama",
    description:
      "Gülbahar Mahallesi’nde halılarınızı uzman ekibimizle hijyenik şekilde temizliyor, evinize teslim ediyoruz."
  }
];

const SisliSidebar = () => {
  const location = useLocation();

  return (
    <div className="mt-2 text-[#003132]">
      <h2 className="text-lg font-semibold mb-2 uppercase tracking-wide text-center">ŞİŞLİ SERVİS ALANLARI</h2>

      <div className="bg-[#f1f5f9] p-4 rounded-xl shadow-sm space-y-3 border border-gray-200">
        {ServiceArea.map((area, index) => (
          <div key={index}>
            <Link
              to={area.path}
              className={`block text-sm font-semibold px-3 py-1 rounded-lg transition-all duration-200 ${
                location.pathname === area.path
                  ? "bg-red-600 text-white"
                  : "text-red-900 hover:bg-green-100 hover:text-red-800"
              }`}
            >
              {area.label}
            </Link>
            <p className="text-xs text-gray-600 mt-1 pl-1">{area.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SisliSidebar;
